import { GET_ALL_User, GET_USER_DETAILS } from "./actions";

const initialState = {
  userList: {
    docs: [],
    totalDocs: 0,
    limit: 10,
    page: 1,
    totalPages: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,
  },
  getUserData: {},
  loading: true,
};

const userReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_ALL_User:
      return {
        ...state,
        userList: payload,
        loading: false,
      };
    case GET_USER_DETAILS:
      return {
        ...state,
        getUserData: payload,
        loading: false,
      };
    default:
      return state;
  }
};
export default userReducer;
